// extracted by mini-css-extract-plugin
module.exports = {"UnwantedService":"UnwantedServicesTable_UnwantedService__ccMx9"};